import { render, staticRenderFns } from "./SelectJournalPayment.vue?vue&type=template&id=eb0b7036"
import script from "./SelectJournalPayment.vue?vue&type=script&lang=js"
export * from "./SelectJournalPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb0b7036')) {
      api.createRecord('eb0b7036', component.options)
    } else {
      api.reload('eb0b7036', component.options)
    }
    module.hot.accept("./SelectJournalPayment.vue?vue&type=template&id=eb0b7036", function () {
      api.rerender('eb0b7036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/SelectJournalPayment.vue"
export default component.exports